import PropTypes from 'prop-types';
import ReviewVideo from '../recorder-components/review-video';
import ThankviewLibrary from '../thankview-library';
import ThankviewRecorder from '../thankview-recorder';
import ThankviewDefaultSettings from '../thankview-default-settings';
import { Modal } from '@evertrue/et-components';
import { useSignalVideoModalContext } from 'apps/signal-video/contexts/use-signal-video-modal-context';

const SignalVideoController = ({
  uploadVideo,
  processingVideoState,
  onCopyVideo,
  setShowDefaultSettingsModal,
  handleUploadClick,
}) => {
  const {
    isThankviewModalOpen,
    handleCloseThankviewModal,
    modalView: { view },
  } = useSignalVideoModalContext();

  return (
    <Modal
      isOpen={isThankviewModalOpen}
      closeModal={handleCloseThankviewModal}
      size={view === 'settings' ? 'small' : 'dynamic'}
    >
      {view === 'library' ? (
        <ThankviewLibrary onCopyVideo={onCopyVideo} />
      ) : view === 'recorder' ? (
        <ThankviewRecorder uploadVideo={uploadVideo} processingVideoState={processingVideoState} />
      ) : view === 'review' ? (
        <ReviewVideo onCopyVideo={onCopyVideo} />
      ) : (
        <ThankviewDefaultSettings
          setShowDefaultSettingsModal={setShowDefaultSettingsModal}
          handleUploadClick={handleUploadClick}
        />
      )}
    </Modal>
  );
};

SignalVideoController.propTypes = {
  uploadVideo: PropTypes.func.isRequired,
  processingVideoState: PropTypes.string.isRequired,
  onCopyVideo: PropTypes.func,
  setShowDefaultSettingsModal: PropTypes.func.isRequired,
  handleUploadClick: PropTypes.func.isRequired,
};

export default SignalVideoController;
